module.exports = __webpack_public_path__ + "046051f4eda57d95c9088eb9dabe0289.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/drums/13_C3.mp3
// module id = 53
// module chunks = 0